/*
 * @Author: edvardchen
 * @Date: 2018-01-26 20:09:36
 * @Last Modified by: zloongjiang
 * @Last Modified time: 2018-07-08 16:24:05
 */

// @flow
import React from 'react';
import Comment from 'uistyles/comby/comment';
import Card from 'uistyles/comby/card';

import Praise from '../Comment/comby/Praise';
import renderCommentContent from '../Comment/comby/renderCommentContent';
import { type Comment as CommentType } from '../../ducks/types';
import { track, redirect } from '../../utility/index';
import CommentImage from '../Comment/comby/CommentImage';

const CommentItem = Comment.Item;
const { Title: CardTitle, Content: CardContent } = Card;

// let lastOptionsShownComment;
const onTalkClick = (event, { id } = {}) => {
  event.preventDefault();
  event.stopPropagation();
  track({
    location: 'attach',
    object: 'circle_talk',
    action: 'open',
    id,
  });
  const url = event.currentTarget.href;
  redirect(url);
};

const quoteStyle = {
  padding: '8px',
  backgroundColor: '#ebebeb',
};

type Props = CommentType & {
  onReply?: Function,
  onAvatarClick?: Function,
};

export const Item = (props: Props) => {
  const { user, referComment, time, content, praised, praiseNum, onPraise, border, onReply, onAvatarClick } = props;
  const headerRight = [<Praise key="praise" {...{ praised, praiseNum, onClick: onPraise }} />];
  let at;
  let quote;
  const text = renderCommentContent(content, { onTalkClick });
  const images = props.images.filter((item) => item.sPicUrl);
  if (images.length) {
    if (text.length) {
      text.push(<br key={'br_0'} />);
    }
    text.push(...images.map((item, idx) => <CommentImage img={item} key={`image_${idx}`} />));
  }

  if (referComment) {
    const {
      user: { name },
      content: referContent,
    } = referComment;
    at = name;
    quote = (
      <div style={quoteStyle}>
        {name}: {renderCommentContent(referContent, { onTalkClick })}
      </div>
    );
  }
  return (
    <CommentItem
      onClick={onReply}
      avatarName={user.name}
      avatarSrc={user.faceIcon}
      avatarClick={onAvatarClick}
      {...{ at, quote, headerRight, text, border }}
      bottomLeft={<time>{time}</time>}
    ></CommentItem>
  );
};

export const List = ({ items, onReply, onAvatarClick, onPraise, children }: *) => (
  <Card>
    <CardTitle>相关评论</CardTitle>
    <CardContent>
      <Comment>
        {items.map((item) => (
          <Item
            {...item}
            key={item.id}
            {...{ onReply, onAvatarClick }}
            onPraise={() => {
              onPraise(item);
            }}
          />
        ))}
      </Comment>
    </CardContent>
    {children}
  </Card>
);
